import { createFileRoute } from '@tanstack/react-router';

import { RisksPage } from '@/features/owner/risks-page';

export const Route = createFileRoute('/_app/projects/$projectId/risks')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <RisksPage projectId={projectId} />;
}
